/**
 * Block: pausemenu, view.
 */

import { toggleExpanded } from '../../scripts/utils/toggle-expanded';

// Apply toggleExpanded to all pausemenu menus on document ready.
document.addEventListener( 'DOMContentLoaded', () => {
	const menus = document.querySelectorAll(
		'.wp-block-boldlygo-pausemenu__menu'
	);

	menus.forEach( ( menu ) => {
		// Element that, when clicked outside of, will close the menu.
		const content = menu.querySelector(
			'.wp-block-boldlygo-pausemenu__menu-content'
		);
		toggleExpanded( menu, { clickOutsideTarget: content } );
	} );
} );
